var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    clipPath: "url(#clip0_4498_13819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.26758 4.88851H9.60091V6.22184H8.26758V4.88851ZM8.26758 7.55518H9.60091V11.5552H8.26758V7.55518ZM8.93425 1.55518C5.25424 1.55518 2.26758 4.54184 2.26758 8.22184C2.26758 11.9018 5.25424 14.8885 8.93425 14.8885C12.6142 14.8885 15.6009 11.9018 15.6009 8.22184C15.6009 4.54184 12.6142 1.55518 8.93425 1.55518ZM8.93425 13.5552C5.99425 13.5552 3.60091 11.1618 3.60091 8.22184C3.60091 5.28184 5.99425 2.88851 8.93425 2.88851C11.8742 2.88851 14.2676 5.28184 14.2676 8.22184C14.2676 11.1618 11.8742 13.5552 8.93425 13.5552Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4498_13819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.933594 0.221924)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.9f159498bb7f18bd960fe827b29966db.svg";
export { ForwardRef as ReactComponent };